/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import * as React from 'react';

import { Icon, IconColor, IconName } from 'app/common/components/controls';
import { Yellow100 } from '@trello/colors';
import styles from './banner.less';

interface BannerProps {
  children: React.ReactNode;
  inlinePadding?: boolean;
  onDismiss?: () => void;
  bannerColor?: string;
  className?: string;
  infoUrl?: string;
  useLightText?: boolean;
  alignCloseTop?: boolean;
  shadow?: boolean;
  roundedCorners?: boolean;
}

const Banner = ({
  children,
  inlinePadding,
  infoUrl,
  onDismiss,
  bannerColor = Yellow100,
  className = '',
  useLightText,
  alignCloseTop,
  shadow,
  roundedCorners,
}: BannerProps) => {
  return (
    <div
      className={classNames(
        styles.bannerContainer,
        { [styles.inlinePadding]: inlinePadding },
        { [styles.bannerShadow]: shadow },
        { [styles.roundedCorners]: roundedCorners },
        className,
      )}
      style={{
        backgroundColor: bannerColor,
      }}
    >
      <div
        className={classNames(styles.textContent, {
          [styles.lightText]: useLightText,
        })}
      >
        {children}{' '}
      </div>
      {infoUrl && (
        <a
          className={classNames(styles.actionButton, {
            [styles.alignTop]: alignCloseTop,
          })}
          href={infoUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon className={styles.help} name={IconName.Information} />
        </a>
      )}
      {onDismiss && (
        <div
          className={classNames(styles.actionButton, {
            [styles.alignTop]: alignCloseTop,
          })}
          onClick={onDismiss}
          role="button"
          data-test-id="bannerCloseButton"
        >
          <Icon
            name={IconName.Close}
            className={styles.icon}
            large
            color={useLightText ? IconColor.Light : IconColor.Dark}
          />
        </div>
      )}
    </div>
  );
};

export default Banner;
